/* faq-nav-scroll.js — hand-authored, NOT part of the webpack app.js bundle.
 *
 * On the FAQ page (sections/page-faq.liquid) the sticky nav is a horizontal
 * scroll strip on MOBILE (< 768px). The app.js `faq` module already toggles the
 * `.is-active` class on the current `.faq-nav__tab` as you scroll (via an
 * IntersectionObserver on the panels). But when a tab far down the list becomes
 * active, it can sit off-screen inside the horizontal scroller.
 *
 * This script watches the tabs for `.is-active` changes and scrolls the strip so
 * the active tab stays visible. Desktop is a vertical list (no overflow scroll),
 * so this is a no-op there.
 *
 * (The related "two dark tabs after tapping" bug is a CSS issue — a sticky
 * :hover left on the tapped tab — and is fixed in additional.css, not here.)
 *
 * Loaded with `defer` after app.js so the faq module has wired up its tabs and
 * the DOM is ready.
 */
(function () {
  'use strict';

  var strip = document.querySelector('.faq-nav .flex');
  var tabs = document.querySelectorAll('.faq-nav__tab');
  if (!strip || !tabs.length) return;

  var mqMobile = window.matchMedia('(max-width: 767px)');

  function scrollActiveIntoView() {
    if (!mqMobile.matches) return;
    var active = strip.querySelector('.faq-nav__tab.is-active');
    if (!active) return;

    // Center the active tab within the visible strip where possible; clamp to
    // the scrollable range so the first/last tabs sit flush at the edges.
    var target =
      active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
    var max = strip.scrollWidth - strip.clientWidth;
    target = Math.max(0, Math.min(target, max));

    strip.scrollTo({ left: target, behavior: 'smooth' });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].target.classList.contains('is-active')) {
        scrollActiveIntoView();
        return;
      }
    }
  });

  tabs.forEach(function (tab) {
    observer.observe(tab, { attributes: true, attributeFilter: ['class'] });
  });

  // Sync on load in case a tab is already active off-screen.
  scrollActiveIntoView();
})();
